import { Box, Button, IconButton, Text, TextButton } from "@wix/design-system";
import { ArrowUpSmall, RegenerateSparkleSmall } from "@wix/wix-ui-icons-common";
import type { FC } from "react";
import "./SuggestionButtons.css";
import { useSuggestions } from "./useSuggestions";
import { TEXT_STANDARD_PRIMARY_COLOR } from "@wix/picasso-common";
import { useMobile } from "../../../hooks/useMobile";

const RotatedArrow: FC<{ degrees?: number }> = ({ degrees = 45 }) => (
  <Box paddingLeft="5px">
    <ArrowUpSmall
      color={TEXT_STANDARD_PRIMARY_COLOR}
      style={{ transform: `rotate(${degrees}deg)` }}
    />
  </Box>
);

interface SuggestionButtonsProps {
  onSelectPrompt: (prompt: string) => void;
}

export const SuggestionButtons: FC<SuggestionButtonsProps> = ({
  onSelectPrompt,
}) => {
  const {
    currentSuggestions,
    handleRegenerateClick,
    handleSuggestionClick,
    t,
  } = useSuggestions(onSelectPrompt);
  const isMobile = useMobile();

  return (
    <Box direction="vertical" marginTop={4} width="100%">
      {isMobile ? (
        <Box width="100%" align="space-between">
          <Text size="small">
            {t("landing.suggestion.notSureWhereToStartMobile")}
          </Text>
          <TextButton
            size="small"
            onClick={handleRegenerateClick}
            prefixIcon={<RegenerateSparkleSmall />}
          >
            {t("landing.suggestion.regenerate")}
          </TextButton>
        </Box>
      ) : (
        <Text size="small">{t("landing.suggestion.notSureWhereToStart")}</Text>
      )}
      <Box
        paddingTop="12px"
        gap={2}
        flexWrap="wrap"
        align={isMobile ? "center" : "left"}
        width="100%"
      >
        {currentSuggestions.map((suggestion) => (
          <Button
            className="suggestion-button"
            key={suggestion.key}
            skin="dark"
            priority="secondary"
            size="small"
            onClick={() => handleSuggestionClick(suggestion)}
          >
            {t(suggestion.translationKey)}
          </Button>
        ))}
        {!isMobile && (
          <Button
            skin="light"
            prefixIcon={<RegenerateSparkleSmall />}
            size="small"
            onClick={handleRegenerateClick}
          >
            {t("landing.suggestion.regenerate")}
          </Button>
        )}
      </Box>
    </Box>
  );
};
